module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("As always, my gratitude goes to Jennifer Enderlin, editor extraordinaire, for believing in this book and making it even better …")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("To Helen Breitwieser, for being a superb advocate of my work …")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("And to my fearless and peerless critique group, Susan Wiggs, Betty Traylor Gyenes, Christina Dodd, and Joyce Bell, for providing the very best in advice, support, brainstorming, and most of all, friendship.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0